// ProtectedRoute.js
import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchCookie } from "./FetchCookie";
import SpinnerLoad from "./Spinner";

export default function ProtectedRoute({ children, role }) {
  const [user, setUser] = useState(null); // State to hold user data
  const [loading, setLoading] = useState(true); // State to handle loading state
  const location = useLocation();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userData = await fetchCookie(); // Fetch the user data from cookies
        setUser(userData || null); // Set the user data in state
      } catch (error) {
        console.error("Error fetching user data:", error);
        setUser(null);
      } finally {
        setLoading(false); // Set loading to false once data is fetched
      }
    };

    fetchUser(); // Call the async function
  }, []);

  // If loading, show a loading spinner or message
  if (loading) {
    return (
      <div>
        <SpinnerLoad />
      </div>
    );
  }

  const userType = user?.user?.user_type;

  // If user is not authenticated or incomplete, redirect to login and preserve 'from'
  if (!userType) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Check user role
  if (role && userType !== role) {
    return <Navigate to="/" replace />;
  }

  return children; // Render children if role matches
}